import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isNil } from 'lodash';

import { Space } from 'antd';
import { Button, SkeletonLoader, Loader } from '@life-line-lab/components-react';

import './verify-email-view.scss';
import useQuery from 'Hooks/query.hook';

interface VerifyEmailViewProps {
  status: 'idle' | 'loading' | 'success' | 'error';
  onSetVerifyToken: (input: {
    emailToken: string,
    key: string,
    passToken?: string,
  }) => void;
}

const VerifyEmailView: React.FC<VerifyEmailViewProps> = ({ status, onSetVerifyToken }) => {
  let query = useQuery();
  const history = useHistory();
  const { t } = useTranslation();

  const [message, setMessage] = useState<string>('');
  const isLoading = status === 'idle' || status === 'loading';

  const emailToken = query.get('emailToken') || "";
  const passToken = query.get('passToken') || "";
  const key = query.get('key') || "";

  useEffect(() => {
    onSetVerifyToken({ emailToken, passToken, key });
  }, [])

  useEffect(() => {
    if (status === 'success') {
      setMessage(t('txt.verifyEmailSuccess'))
    }

    if (status === 'error') {
      setMessage(t('txt.verifyEmailError'))
    }
  }, [status])

  if (status === 'success' && !isNil(passToken)) {
    return (
      <div className="center">
        <Loader type="spinner" />
      </div>
    )
  }
  else {
    return (
      <div className="verify-email-view">
        <div className="view">
        <Space className="verify-email-view--inner" direction="vertical" size="large">
          {isLoading &&
            <SkeletonLoader type="default" />
          }

          {!isLoading &&
            <React.Fragment>
              <div dangerouslySetInnerHTML={{ __html: message  }} />

              <div>
                <Button
                  type="primary"
                  label={t('action.done')}
                  size="large"
                  onClick={() => history.push('/login')}
                />

                <Button
                  type="link"
                  label={t('action.resendVerifyEmail')}
                  onClick={() => history.push('/resend-verify-email')}
                />
              </div>
            </React.Fragment>
          }
        </Space>
        </div>
      </div>
    )
  }
}

export default VerifyEmailView;
